<template>
  <section class="section-index-table">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div v-if="stations !== null"  class="restrictions-settings">
                <div class="index-table restriction-table col-12">
                  <div class="user-stations-name input-wr">
                    <span :style="{color: 'black', 'font-size' : '16px', 'font-weight': 'bolder'}">Станции</span>
                  </div>
                  <div class="input-wr checkbox-users col-auto" v-for="(stationTitle, stationId) in this.stations" v-bind:key="stationId">
                    <input type="checkbox" :id="'station-' + stationId" :value=stationId v-model="filter.stationIds">
                    <label :for="'station-' + stationId">{{stationTitle}}</label>
                  </div>
              </div>
            <div class="col-3" style="margin-top: 18px;">
              <flat-pickr
                v-model="dateTime"
                :config="pickerConfig"
                class="form-control"
                placeholder="Выберите дату"
                name="date"></flat-pickr>
            </div>
            <div class="col-12 col-md-auto">
              <div class="confirm-restrictions">
                <div class="confirm confirm-restrictions__button" @click="getRestrictionsHistory()">Просмотр истории</div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="row">
        <div class="col-12 index-table-col">
          <table v-if="restrictions !== null" class="index-table restriction-table">
            <tr>
              <th class="th-name th-name-restrictions">
                <span>Фотогальваническая система</span>
              </th>
              <th class="th-power-today"><span>Ограничение kW</span></th>
              <th class="th-power-today"><span>Ограничение %</span></th>
              <th class="th-power-today"><span>Когда внесено</span></th>
              <th class="th-power-today"><span>Успешно</span></th>
            <tr v-for="stationTable in restrictions" v-bind:key="stationTable.id">
              <td>
                <a href="#">
                  {{stationTable.stationName}}
                </a>
              </td>
              <td><div><span>Ограничение kW</span><b></b><i>
                {{String(stationTable.value)}}
              </i></div></td>
              <td><div><span>Ограничение %</span><b></b><i>
              {{calculateRestrictionPercent(stationTable.stationPower, stationTable.value)}}
              </i></div></td>
              <td><div><span>Дата и время</span><b></b><i>
                {{formatDate(stationTable.date) +' '+ formatTime(stationTable.date)}}
              </i></div></td>
              <td><div><span>Успешно</span><b></b><i>
                {{stationTable.success ? 'Да' : 'Нет'}}
              </i></div></td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import StationAPI from '../../api/station'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import '../../../node_modules/flatpickr/dist/themes/dark.css'

export default {
  name: 'RestrictionsHistoryFilterTable',
  components: {
    flatPickr
  },
  data () {
    return {
      restrictions: null,
      dateTime: null,
      pickerConfig: {
        dateFormat: 'Y-m-d H:i',
        mode: 'range',
        onChange: this.pickerChange,
        maxDate: new Date(),
        enableTime: true,
        time_24hr: true
      },
      filter: {
        stationIds: [],
        startDate: null,
        endDate: null
      }
    }
  },
  mounted () {
    this.$store.dispatch('users/findAll')
  },
  computed: {
    user () {
      return this.$store.getters[ 'user/hasUser' ] ? this.$store.getters[ 'user/user' ] : {
        isSuper: false
      }
    },
    stations () {
      return this.$store.getters['users/stations']
    }
  },
  methods: {
    calculateRestrictionPercent (power, value) {
      return this.round(value / (parseFloat(String(power).replace(',', '.')) * 10))
    },
    round (val) {
      return Math.round(val)
    },
    formatDate (timestamp) {
      return moment.unix(timestamp)
        .subtract(2, 'hours')
        .format('DD/MM/YYYY')
    },
    formatTime (timestamp) {
      return moment.unix(timestamp)
        .subtract(2, 'hours')
        .format('HH:mm')
    },
    pickerChange (selectedDates, dateStr, instance) {
      let result; let date = dateStr.replace('to', '#')
      instance.element.value = date
      result = date.match(/(\d{4}-\d{2}-\d{2} \d{2}:\d{2})\s#\s(\d{4}-\d{2}-\d{2} \d{2}:\d{2})/)

      if (result !== null) {
        this.filter.startDate = result[ 1 ] + ':00'
        this.filter.endDate = result[ 2 ] + ':00'
      } else {
        result = date.match(/(\d{4}-\d{2}-\d{2})/)
        if (result !== null) {
          console.log(result)
          this.filter.startDate = result[0] + ' 00:00:00'
          this.filter.endDate = result[0] + ' 23:59:59'
        }
      }
    },
    getRestrictionsHistory () {
      let _this = this
      if (this.filter.stationIds.length > 0) {
        StationAPI.filterRestrictionHistory(this.filter).then((r) => {
          _this.restrictions = r.data
        })
      }
    }
  }
}
</script>

<style>
.index-table td div i.inv.warn b:first-child {
  background: #eabe43;
}
</style>
